/**
 * @author Adam Vlasek <adam.vlasek@styrax.cz>
 */

/*
Stackovani zmen odehranych behem nejakeho intervalu.
Registujete si zmenu, pokud ve stanovenem intervalu prijde jina zmena, tak se interval resetuje a puvodni zmena se zapomene. Pokud interval vypsi, zmena se aplikuje.
Napriklad pro odesilani zmen az po ukonceni uprav. (uzivatel pise, 1000ms pod stisku posledni klavesy se odeslou data)
*/
export default class TimeoutStack {

    private timeout: number;
    private time: ReturnType<typeof setTimeout> | undefined;

    public constructor(timeout: number) {
        this.time = undefined;
        this.timeout = timeout;
    }

    public push(fnc: any): void {
        this.clear();

        this.time = setTimeout(
            fnc,
            this.timeout
        );
    }

    public clear() {
        if (this.time) clearTimeout(this.time);
    }

}
